export default __webpack_public_path__ + "static/media/sd.2fc59dda.svg";